import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, DatePicker, Checkbox, Row, Col, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import "../Pages/CSS/DonnesBases.css";
import moment from 'moment';
import dayjs from "dayjs";

const OrganeIpm = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Récupérer les données de l'API
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/organe-ipm'); // Remplacez par l'URL de votre API
      setData(response)
    } catch (error) {
      message.error('Erreur lors de la récupération des données');
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {

  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  // Colonnes de la table
  const columns = [
    {
      title: 'Nom',
      dataIndex: 'nom',
      key: 'nom',
    },
    {
      title: 'Prénom',
      dataIndex: 'prenom',
      key: 'prenom',
    },
    {
      title: 'Entreprise',
      dataIndex: 'entreprise',
      key: 'entreprise',
    },
    {
      title: 'Téléphone',
      dataIndex: 'tel',
      key: 'tel',
    },
    {
      title: 'Email',
      dataIndex: 'mail',
      key: 'mail',
    },
    {
      title: 'Adresse',
      dataIndex: 'adresse',
      key: 'adresse',
    },
    {
      title: 'Début Mandat',
      dataIndex: 'dateFonction',
      key: 'dateFonction',
      render: (text) => text.format('DD/MM/YYYY'), // Afficher la date dans un format lisible
    },
    {
      title: 'Organe',
      dataIndex: 'organe',
      key: 'organe',
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'flex-end' }}>
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
          Ajouter
        </Button>
      </div>
      <Table
        scroll={{
          x: true,
        }}
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        pagination={{
          pageSize: 15, // le nombre d'éléments par page
        }}
        className="custom-header1-table"
        bordered
        showSorterTooltip={false}
        columns={columns}
        dataSource={data}
        loading={loading} />

      <Modal
        title="Ajouter un Organe IPM"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={850}
        okText="Enregistrer"
        cancelText="Annuler"
      >
        <Form
          form={form}
          layout="vertical"
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="nom"
                label="Nom"
                rules={[{ required: true, message: 'Veuillez entrer le nom' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="prenom"
                label="Prénom"
                rules={[{ required: true, message: 'Veuillez entrer le prénom' }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="entreprise"
                label="Entreprise"
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="tel"
                label="Téléphone"
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="mail"
                label="Email"
                rules={[{ type: 'email', message: 'Veuillez entrer un email valide' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="adresse"
                label="Adresse"
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="dateFonction"
                label="Date de Fonction"
                rules={[{ required: true, message: 'Veuillez sélectionner la date de fonction' }]}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  disabledDate={(current) => current && current > dayjs().endOf('day')}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="dateFonction"
                label="Date Embauche"
                rules={[{ required: true, message: 'Veuillez sélectionner la date de fonction' }]}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  disabledDate={(current) => current && current > dayjs().endOf('day')}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            name="organe"
            label="Organe"
          >
            <Checkbox.Group>

              <Checkbox value="CR">CR (Collège des représentants)</Checkbox>
              <Checkbox value="CA">CA (Conseil d'administration)</Checkbox>
              <Checkbox value="BE">BE (Bureau d'exécution)</Checkbox>
              <Checkbox value="GE">GE (Gérance)</Checkbox>

            </Checkbox.Group>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default OrganeIpm;
